import type { ComponentPropsWithoutRef } from "react";

import { cx } from "../../lib/cx";
import { Icon, type IconName } from "../core/Icon";
import s from "./Toast.module.css";

export type ToastTone = "success" | "info" | "warning" | "danger";

const ICONO: Record<ToastTone, IconName> = {
  success: "check-circle-2",
  info: "info",
  warning: "alert-triangle",
  danger: "alert-circle",
};

export interface ToastProps extends Omit<ComponentPropsWithoutRef<"div">, "title"> {
  title: string;
  message?: string;
  tone?: ToastTone;
  onDismiss?: () => void;
}

/** La pieza visual de un aviso. El posicionamiento y el auto-cierre los pone `ToastProvider`. */
export function Toast({ title, message, tone = "success", onDismiss, className, ...rest }: ToastProps) {
  return (
    <div role="status" className={cx(s.toast, "klavia-dark", className)} data-tone={tone} {...rest}>
      <span className={s.icono}>
        <Icon name={ICONO[tone]} size={18} />
      </span>
      <div className={s.textos}>
        <div className={s.titulo}>{title}</div>
        {message ? <div className={s.mensaje}>{message}</div> : null}
      </div>
      {onDismiss ? (
        <button type="button" aria-label="Cerrar" className={s.cerrar} onClick={onDismiss}>
          <Icon name="x" size={15} />
        </button>
      ) : null}
    </div>
  );
}
